import { useState } from "react";
import "./verification.scss";
import bankGif from "assets/images/v2/bank.gif";
import accountConnectedGif from "assets/images/v2/account-connected.gif";
import { Button } from "components/v2/button/Button";
import { TOSDrawer } from "../tos-drawer/TOSDrawer";
import { VerificationType } from "pages/online-verification/verificationService";
import { ReactComponent as SackMoneyIcon } from "assets/images/v2/sack-money.svg";
import { ReactComponent as XmarkLargeIcon } from "assets/images/v2/xmark-large.svg";

import useDesktopChecker from "hooks/useDesktopChecker";

interface VerificationProps {
  verificationType: VerificationType;
  closeDrawerForMobile: () => void;
  status: string;
  handlesuccessfullVerification: () => void;
}

export default function Verification({ verificationType, closeDrawerForMobile, status, handlesuccessfullVerification }: Readonly<VerificationProps>) {
  const [showVerificationDrawer, setShowVerificationDrawer] = useState(false);
  const isDesktop = useDesktopChecker();
  
  const toggleVerificationDrawer = () => {
    setShowVerificationDrawer(!showVerificationDrawer);
  };

  const handleVerificationSuccess = () => {
    setShowVerificationDrawer(false);
    handlesuccessfullVerification();
  }

  return (
    <div className="verification">
      <div className="verification__header">
        {!isDesktop && (
          <button type="button" className="verification__x-mark" onClick={closeDrawerForMobile} aria-label="Close verification">
            <XmarkLargeIcon />
          </button>
        )}
      </div>
      <div className="verification__body">
        {status.toLowerCase() === "completed" ? (
          <>
            <img className="verification__img" src={accountConnectedGif} alt="Accounts Connected" />
            <p className="verification__text">Accounts Connected!</p>
          </>
        ) : (
          <>
            <img className="verification__img" src={bankGif} alt="Asset Verification" />
            <p className="verification__text">Please click Connect to connect your bank accounts and verify your assets</p>
          </>
        )}
      </div>
      {status.toLowerCase() !== "completed" && <Button label="Connect" variant="primary" onClick={toggleVerificationDrawer} icon={<SackMoneyIcon />} iconPosition="left" />}
      <TOSDrawer
        showVerificationDrawer={showVerificationDrawer}
        setShowVerificationDrawer={toggleVerificationDrawer}
        verificationType={verificationType}
        handleSuccessfullVerification={handleVerificationSuccess}
      />
    </div>
  );
}
